// /// Menu
// //import Metismenu from "metismenujs";
// import React, { useContext, useEffect, useReducer, useState } from "react";
// /// Scroll
// import PerfectScrollbar from "react-perfect-scrollbar";
// import Collapse from "react-bootstrap/Collapse";
// /// Link
// import { Link, NavLink } from "react-router-dom";
// import { useScrollPosition } from "@n8tb1t/use-scroll-position";
// import { ThemeContext } from "../../../context/ThemeContext";
// import { MenuList } from "./Menu";
// import { useSelector } from "react-redux";

// const reducer = (previousState, updatedState) => ({
// ...previousState,
// ...updatedState,
// });

// const initialState = {
// active: "",
// activeSubmenu: "",
// };

// const SideBar = () => {
// const userDetails = useSelector((state) => state.auth.userDetails);
// const scrollRef = React.useRef(null);

// const userRole =
// typeof userDetails?.role === "string"
// ? userDetails.role.trim()
// : userDetails?.role?.name || "";

// const { iconHover, sidebarposition, headerposition, sidebarLayout } =
// useContext(ThemeContext);

// const [state, setState] = useReducer(reducer, initialState);
// const [isMenuOpen, setIsMenuOpen] = useState(false);

// /** --------------------------------
// * TOGGLE BUTTON LISTENER
// * -------------------------------- */
// useEffect(() => {
// const btn = document.querySelector(".nav-control");
// const wrapper = document.querySelector("#main-wrapper");

// if (!btn || !wrapper) return;

// const toggleFunc = (e) => {
// e.preventDefault();
// setIsMenuOpen((prev) => !prev);
// };

// btn.addEventListener("click", toggleFunc);
// return () => btn.removeEventListener("click", toggleFunc);
// }, []);

// /** --------------------------------
// * COLLAPSE & SCROLL REFRESH FIX
// * -------------------------------- */
// useEffect(() => {
// const wrapper = document.querySelector("#main-wrapper");
// if (!wrapper) return;

// if (isMenuOpen) {
// wrapper.classList.add("menu-toggle");
// } else {
// wrapper.classList.remove("menu-toggle");
// }

// // Refresh PerfectScrollbar after transition
// setTimeout(() => {
// if (scrollRef.current && scrollRef.current.update) {
// scrollRef.current.update();
// }
// window.dispatchEvent(new Event("resize")); // helps on mobile
// }, 350);
// }, [isMenuOpen]);

// /** --------------------------------
// * HEART ICON EFFECT
// * -------------------------------- */
// useEffect(() => {
// const heart = document.querySelector(".heart");
// if (!heart) return;

// const heartBlast = () => heart.classList.toggle("heart-blast");
// heart.addEventListener("click", heartBlast);

// return () => {
// heart.removeEventListener("click", heartBlast);
// };
// }, []);
 

// /** --------------------------------
// * SCROLL HIDE HEADER FEATURE
// * -------------------------------- */
// const [hideOnScroll, setHideOnScroll] = useState(true);
// useScrollPosition(
// ({ prevPos, currPos }) => {
// const isShow = currPos.y > prevPos.y;
// if (isShow !== hideOnScroll) setHideOnScroll(isShow);
// },
// [hideOnScroll]
// );

// const handleMenuActive = (status) => {
// setState({ active: status });
// if (state.active === status) {
// setState({ active: "" });
// }
// };

// const handleSubmenuActive = (status) => {
// setState({ activeSubmenu: status });
// if (state.activeSubmenu === status) {
// setState({ activeSubmenu: "" });
// }
// };

// let path = window.location.pathname;
// path = path.split("/");
// path = path[path.length - 1];

// return (
// <div
// className={`dlabnav ${iconHover} ${
// sidebarposition.value === "fixed" &&
// sidebarLayout.value === "horizontal" &&
// headerposition.value === "static"
// ? hideOnScroll > 120
// ? "fixed"
// : ""
// : ""
// }`}
// >
// <PerfectScrollbar
// className="dlabnav-scroll"
// containerRef={(ref) => (scrollRef.current = ref)}
// >
// <ul className="metismenu" id="menu">
// {MenuList.filter(
// (menu) => !menu.allowedRoles || menu.allowedRoles.includes(userRole)
// ).map((data, index) => {
// let menuClass = data.classsChange;
// if (menuClass === "menu-title") {
// return (
// <li className={menuClass} key={index}>
// {data.title}
// </li>
// );
// } else {
// return (
// <li
// className={`${state.active === data.title ? "mm-active" : ""}`}
// key={index}
// >
// {data.content && data.content.length > 0 ? (
// <Link
// to="#"
// className="has-arrow"
// onClick={() => handleMenuActive(data.title)}
// >
// {data.iconStyle}
// <span className="nav-text">{data.title}</span>
// </Link>
// ) : (
// <Link to={data.to} onClick={() => setIsMenuOpen(false)}>
// {data.iconStyle}
// <span className="nav-text">{data.title}</span>
// </Link>
// )}

// <Collapse in={state.active === data.title}>
// <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
// {data.content &&
// data.content.map((child, childIndex) => {
// return (
// <li
// key={childIndex}
// className={`${
// state.activeSubmenu === child.title ? "mm-active" : ""
// }`}
// >
// {child.content && child.content.length > 0 ? (
// <>
// <Link
// to={child.to}
// className={child.hasMenu ? "has-arrow" : ""}
// onClick={() => handleSubmenuActive(child.title)}
// >
// {child.title}
// </Link>

// <Collapse in={state.activeSubmenu === child.title}>
// <ul
// className={`${
// menuClass === "mm-collapse" ? "mm-show" : ""
// }`}
// >
// {child.content
// .filter(
// (sub) =>
// !sub.allowedRoles ||
// sub.allowedRoles.includes(userRole)
// )
// .map((sub, subIndex) => {
// return (
// <li key={subIndex}>
// <Link
// to={sub.to}
// className={`${
// path === sub.to ? "mm-active" : ""
// }`}
// >
// {sub.title}
// </Link>
// </li>
// );
// })}
// </ul>
// </Collapse>
// </>
// ) : (
// <Link to={child.to} onClick={handleMenuClick}>{child.title}</Link>
// )}
// </li>
// );
// })}
// </ul>
// </Collapse>
// </li>
// );
// }
// })}
// </ul>

// <div className="copyright">
// <p>
// <strong>CX360</strong> © 2026 All Rights Reserved
// </p>
// </div>
// </PerfectScrollbar>
// </div>
// );
// };

// export default SideBar;





/// Menu
import React, { useContext, useEffect, useReducer, useState, useCallback } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import { Link, NavLink, useLocation } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { loadMenus, getMenuList, invalidateMenus } from "./Menu"; // [OK] Import invalidateMenus
import { clearAllPersistentFilters } from "../../components/Common/usePersistentFilters";

import { useSelector } from "react-redux";

const reducer = (previousState, updatedState) => ({
 ...previousState,
 ...updatedState,
});

const initialState = {
 active: "",
 activeSubmenu: "",
};

const SideBar = () => {
 const userDetails = useSelector((state) => state.auth.userDetails);
 const scrollRef = React.useRef(null);
 const [menus, setMenus] = useState([]);
 const [loadingMenus, setLoadingMenus] = useState(true);
 const location = useLocation();

 // Improved role calculation
 const getCleanRole = () => {
 const roleObj = userDetails?.role;
 const uiRole = userDetails?.uiRole;
 
 // 1. Try populated role name
 if (typeof roleObj === "object" && roleObj?.name) return roleObj.name;
 
 // 2. Try uiRole (often human readable name)
 if (uiRole && typeof uiRole === "string" && uiRole.length < 30) return uiRole;
 
 // 3. Try role string if it's NOT an ObjectId (ObjectId is 24 chars hex)
 if (typeof roleObj === "string" && !roleObj.match(/^[0-9a-fA-F]{24}$/)) return roleObj;
 
 return "";
 };

 const userRole = getCleanRole().trim().toLowerCase();

 const { iconHover, sidebarposition, headerposition, sidebarLayout, menuToggle, setMenuToggle } =
 useContext(ThemeContext);

 const [state, setState] = useReducer(reducer, initialState);

 const closeSidebarOnMobile = () => {
 if (window.innerWidth <= 991) {
 setMenuToggle(false);
 }
 };

 const handleMenuClick = () => {
   clearAllPersistentFilters();
   closeSidebarOnMobile();
 };

 /** --------------------------------
 * [OK] OPTIMIZED MENU LOADING with USER ROLE & PERMISSION FILTERING
 * -------------------------------- */
 const loadAndFilterMenus = useCallback(async () => {
 setLoadingMenus(true);
 
 // Invalidate cache to ensure we get the latest Menu Manager settings
 invalidateMenus();
 
 await loadMenus();
 const allMenus = getMenuList();
 
 // Normalize strings for flexible matching
 const normalize = (str) => (str || "").toLowerCase().replace(/[:\s_-]/g, "");
 const userPerms = (userDetails?.permissionNames || []).map(p => normalize(p));
 const assignedProjects = userDetails?.assignedProjects || [];
 const assignedWOs = userDetails?.assignedWorkOrders || [];
 
 const hasAccess = (item) => {
  if (!item) return false;
  const role = (userRole || "").trim().toLowerCase();

  // 1 NORMALIZE STRINGS
  const normalize = (str) => (str || "").toLowerCase().replace(/[:\s_-]/g, "");
  const itemKey = normalize(item.key || item.title);
  const userPerms = (userDetails?.permissionNames || []).map(p => normalize(p));

  // Work Orders: enforce dual-permission for non-admins
  const isWorkOrders = itemKey === 'workorders' || itemKey === 'workorder';
  if (isWorkOrders) {
   // Admin always has access
   if (role === 'admin') return true;
   // Everyone else needs BOTH read:workorders AND read:wo
   return (
    userPerms.includes('readworkorders') &&
    userPerms.includes('readwo')
   );
  }

  // Admin ALWAYS has access (for all other items)
  if (role === 'admin') return true;

  // 2 CHECK requiredPermission (from Menu Manager) — if set, must pass
  if (item.requiredPermission && item.requiredPermission.trim() !== "") {
   const aliases = {
    'gc': 'gantt', 'ganttchart': 'gantt', 'boqa': 'boqs',
    'contractorwo': 'contractualwo', 'contractorbilling': 'contractualwobillings',
    'vendorbilling': 'vendorworkorderbillings', 'hira': 'safety', 'mos': 'safety',
    'drawing': 'documents', 'tds': 'documents', 'tc': 'tcs',
    'handover': 'documents', 'indent': 'indents', 'mir': 'mirs',
    'wir': 'wirs', 'jmr': 'jmrs', 'delivery': 'deliveries',
    'workorders': 'workorders', 'billings': 'billings', 'moms': 'moms',
   };
   const req = normalize(item.requiredPermission);
   const rawPK = req.replace(/^(read|create|edit|delete|view|manage)/, '');
   const aliasedPK = aliases[rawPK] || rawPK;
   const hasPerm = (
    userPerms.includes(req) ||
    userPerms.includes(`read${aliasedPK}`) ||
    userPerms.includes(`view${aliasedPK}`) ||
    userPerms.includes(`manage${aliasedPK}`) ||
    userPerms.includes(aliasedPK) ||
    userPerms.includes(`read${rawPK}`) ||
    userPerms.includes(rawPK)
   );
   if (!hasPerm) return false;
  }

  // 3 CHECK MENU MANAGER (allowedRoles)
  if (item.allowedRoles && Array.isArray(item.allowedRoles) && item.allowedRoles.length > 0) {
   const allowed = item.allowedRoles.map((r) => String(r || "").trim().toLowerCase());
   if (allowed.includes(role)) return true;
  }

  // 4 CHECK PERMISSIONS (Fallback/Granular)
  // Global read/view permissions
  if (userPerms.includes("readall") || userPerms.includes("viewall") || userPerms.includes("admin")) return true;

  // Common aliases to map Menu Keys -> Permission Keys
  const aliases = {
   'purchaseorders': 'pos',
   'purchase-orders': 'pos',
   'indent': 'indents',
   'mir': 'mirs',
   'delivery': 'deliveries',
   'inventory': 'inventory',
   'warehouses': 'inventory',
   'inventorypurchaseorders': 'inventory',
   'inventory-purchase-orders': 'inventory',
   'inventorytransfers': 'inventory',
   'inventory-transfers': 'inventory',
   'inventoryissues': 'inventory',
   'inventory-issues': 'inventory',
   'inventorystock': 'inventory',
   'inventorystocksummary': 'inventory',
   'inventorystockledger': 'inventory',
   'jmr': 'jmrs',
   'projects': 'projects',
   'billings': 'billings',
   'userslist': 'users',
   'contractualdebit': 'contractualwo',
   'testcertificateslist': 'tcs',
   'measurementsheets': 'measurement-sheets'
  };

  const permissionKey = aliases[itemKey] || itemKey;

  if (userPerms.includes(`read${permissionKey}`)) return true;
  if (userPerms.includes(`view${permissionKey}`)) return true;
  if (userPerms.includes(permissionKey)) return true;

  return false;
  };
 
 const filteredMenus = allMenus
 .map((menu) => {
 const filteredChildren = (menu.content || []).filter(child => hasAccess(child));
 
 if (hasAccess(menu) || filteredChildren.length > 0) {
 return {
 ...menu,
 content: filteredChildren
 };
 }
 return null;
 })
 .filter(Boolean);

 setMenus(filteredMenus);
 setLoadingMenus(false);
 }, [userRole, userDetails?.permissionNames, userDetails?.assignedProjects, userDetails?.assignedWorkOrders]);

 // Load menus when userRole changes (login/logout/role change)
 useEffect(() => {
 loadAndFilterMenus();
 }, [loadAndFilterMenus]);

 /** --------------------------------
 * AUTO ACTIVE TAB ON MOUNT/NAVIGATE
 * -------------------------------- */
 useEffect(() => {
 if (loadingMenus || menus.length === 0) return;
 
 const currentPath = location.pathname.toLowerCase();
 
 for (const menu of menus) {
 // Check top-level
 if (menu.to && currentPath.includes(menu.to.toLowerCase().replace(/^\//, ''))) {
 setState({ active: menu.title, activeSubmenu: "" });
 return;
 }
 
 // Check first-level children
 if (menu.content && menu.content.length > 0) {
 for (const child of menu.content) {
 if (child.to && currentPath.includes(child.to.toLowerCase().replace(/^\//, ''))) {
 setState({ active: menu.title, activeSubmenu: child.title });
 return;
 }
 
 // Check second-level children
 if (child.content && child.content.length > 0) {
 for (const sub of child.content) {
 if (sub.to && currentPath.includes(sub.to.toLowerCase().replace(/^\//, ''))) {
 setState({ active: menu.title, activeSubmenu: child.title });
 return;
 }
 }
 }
 }
 }
 }
 }, [location.pathname, menus, loadingMenus]);

 /** --------------------------------
 * SCROLL REFRESH FIX
 * -------------------------------- */
 useEffect(() => {
 setTimeout(() => {
 if (scrollRef.current && scrollRef.current.update) {
 scrollRef.current.update();
 }
 window.dispatchEvent(new Event("resize"));
 }, 350);
 }, [menuToggle]);

 /** --------------------------------
 * HEART ICON EFFECT
 * -------------------------------- */
 useEffect(() => {
 const heart = document.querySelector(".heart");
 if (!heart) return;

 const heartBlast = () => heart.classList.toggle("heart-blast");
 heart.addEventListener("click", heartBlast);

 return () => {
 heart.removeEventListener("click", heartBlast);
 };
 }, []);

 /** --------------------------------
 * SCROLL HIDE HEADER FEATURE
 * -------------------------------- */
 const [hideOnScroll, setHideOnScroll] = useState(true);
 useScrollPosition(
 ({ prevPos, currPos }) => {
 const isShow = currPos.y > prevPos.y;
 if (isShow !== hideOnScroll) setHideOnScroll(isShow);
 },
 [hideOnScroll]
 );

 const handleMenuActive = (status) => {
 setState({ active: status });
 if (state.active === status) {
 setState({ active: "" });
 }
 };

 const handleSubmenuActive = (status) => {
 setState({ activeSubmenu: status });
 if (state.activeSubmenu === status) {
 setState({ activeSubmenu: "" });
 }
 };

 let path = window.location.pathname;
 path = path.split("/");
 path = path[path.length - 1];

 return (
 <div
 className={`dlabnav ${iconHover} ${
 sidebarposition.value === "fixed" &&
 sidebarLayout.value === "horizontal" &&
 headerposition.value === "static"
 ? hideOnScroll > 120
 ? "fixed"
 : ""
 : ""
 }`}
 >
 <PerfectScrollbar
 className="dlabnav-scroll"
 containerRef={(ref) => (scrollRef.current = ref)}
 >
 <ul className="metismenu" id="menu">
 {loadingMenus ? (
 <li className="menu-title">Loading menus...</li>
 ) : (
 menus.map((data, index) => {
 let menuClass = data.classsChange;
 
 if (menuClass === "menu-title") {
 return (
 <li className={menuClass} key={index}>
 {data.title}
 </li>
 );
 }

 return (
 <li
 className={`${state.active === data.title ? "mm-active" : ""}`}
 key={index}
 >
 {data.content && data.content.length > 0 ? (
 <Link
 to="#"
 className="has-arrow"
 onClick={() => handleMenuActive(data.title)}
 >
 {data.iconStyle}
 <span className="nav-text">{data.title}</span>
 </Link>
 ) : (
 <Link to={data.to} onClick={handleMenuClick}>
 {data.iconStyle}
 <span className="nav-text">{data.title}</span>
 </Link>
 )}
 {data.content && data.content.length > 0 && (
 <Collapse in={state.active === data.title}>
 <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
 {data.content?.map((child, childIndex) => (
 <li
 key={childIndex}
 className={`${
 state.activeSubmenu === child.title ? "mm-active" : ""
 }`}
 >
 {child.content && child.content.length > 0 ? (
 <>
 <Link
 to={child.to}
 className={child.hasMenu ? "has-arrow" : ""}
 onClick={() => handleSubmenuActive(child.title)}
 >
 {child.iconStyle}
 <span>{child.title}</span>
 </Link>

 {child.content && child.content.length > 0 && (
 <Collapse in={state.activeSubmenu === child.title}>
 <ul
 className={`${
 menuClass === "mm-collapse" ? "mm-show" : ""
 }`}
 >
 {child.content?.map((sub, subIndex) => (
 <li key={subIndex}>
 <Link
 to={sub.to}
 onClick={handleMenuClick}
 className={`${
 path === sub.to ? "mm-active" : ""
 }`}
 >
 {sub.iconStyle}
 <span>{sub.title}</span>
 </Link>
 </li>
 ))}
 </ul>
 </Collapse>
 )}
 </>
 ) : (
 <Link 
 to={child.to} 
 className={path === child.to ? "mm-active" : ""}
 onClick={handleMenuClick}
 >
 {child.iconStyle}
 <span>{child.title}</span>
 </Link>
 )}
 </li>
 ))}
 </ul>
 </Collapse>
 )}
 </li>
 );
 })
 )}
 </ul>

 <div className="copyright text-center">
 <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.3)', letterSpacing: '0.5px' }}>
 <strong style={{ color: 'rgba(255,255,255,0.5)' }}>CX360</strong> &copy; 2026 All Rights Reserved
 </p>
 </div>
 </PerfectScrollbar>
 </div>
 );
};

export default SideBar;
